import styled, { css } from 'styled-components/macro';
import { Body, Colors, TagChip } from '@cognite/cogs.js';

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${Colors['decorative--grayscale--white']};
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--cogs-bg-control--disabled);

  th,
  td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--cogs-greyscale-grey3);
  }

  th {
    background: var(--cogs-greyscale-grey2);
    font-weight: 600;
    font-size: 14px;
  }

  tbody tr:hover {
    background: var(--cogs-greyscale-grey1);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const RuleRow = styled.tr<{ $disabled: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      background: var(--cogs-greyscale-grey1);
      /* Fade the content cells but keep the actions cell fully interactive
         so users can still click "Enable rule" on a disabled row. */
      td:not(:last-child) {
        opacity: 0.55;
      }
    `}
`;

export const DisabledBadge = styled(TagChip)`
  margin-left: 8px;
  border: 0;
  background: var(--cogs-greyscale-grey3);
  color: var(--cogs-greyscale-grey8);
`;

export const ConditionChecksOnlyBadge = styled(TagChip)`
  margin-left: 8px;
  border: 0;
  background: ${Colors['decorative--yellow--200']};
  color: ${Colors['decorative--yellow--700']};
`;

export const EmptyStateMessage = styled(Body)`
  color: var(--cogs-greyscale-grey6);
  font-style: italic;
  text-align: center;
  padding: 2rem;
`;

export const OperatorChip = styled(TagChip)`
  border: 0;
  border-radius: var(--cogs-border-radius--small);
  background: var(--cogs-greyscale-grey3);
  color: var(--cogs-greyscale-grey8);
`;

export const ConditionChecksSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 1rem;
  padding-left: 0.75rem;
  border-left: 2px solid var(--cogs-bg-control--disabled);
  color: ${Colors['text-icon--muted']};
`;
